// export const APIURL = "https://api.dashboardproject.in:4001/api/";
export const APIURL = "https://api.dashboardproject.in/api/";

export const GetCompanyForCompanySelection = "adminLogin/GetCompanyForCompanySelection?id={0}";
export const GetFinancialYearByCompanyName = "adminLogin/GetFinancialYearByCompanyName?id={0}";
export const GetCompanyDataWithCompanyNameAndYear = "adminLogin/GetCompanyDataWithCompanyNameAndYear";
export const UserAuthentication = "adminLogin/UserAuthentication";

// Item Master
export const GetAllItems = "itemMaster/GetAllItems?id={0}";
export const GetItemById = "itemMaster/GetItemById?id={0}";
export const AddEditItems = "itemMaster/AddEditItems";
export const DeleteItemById = "itemMaster/DeleteItemById?id={0}";

// Raw Material Master
export const GetAllRawMaterials = "rawMaterialMaster/GetAllRawMaterials?id={0}";
export const GetRawMaterialById = "rawMaterialMaster/GetRawMaterialById?id={0}";
export const AddEditRawMaterial = "rawMaterialMaster/AddEditRawMaterial";
export const DeleteRawMaterialById = "rawMaterialMaster/DeleteRawMaterialById?id={0}";

// Packing Material Master
export const GetAllPackingMaterials = "packingMaterialMaster/GetAllPackingMaterials?id={0}";
export const GetPackingMaterialById = "packingMaterialMaster/GetPackingMaterialById?id={0}";
export const AddEditPackingMaterial = "packingMaterialMaster/AddEditPackingMaterial";
export const DeletePackingMaterialById = "packingMaterialMaster/DeletePackingMaterialById?id={0}";

export const GetAllItemCategory = "common/GetAllItemCategory";
export const AddEditItemGategory = "itemCategory/AddEditItemGategory";
export const DeleteCategoryById = "itemCategory/DeleteCategoryById?id={0}";

export const AddEditHSNCode = "itemCategory/AddEditHSNCode";
export const DeleteHSNCodeById = "itemCategory/DeleteHSNCodeById?id={0}";
export const GetAllHSNCode = "common/GetAllHSNCode";

export const AddEditRMCategory = "rmCategory/AddEditRMCategory";
export const DeleteRMCategoryById = "rmCategory/DeleteRMCategoryById?id={0}";
export const GetAllRMCategory = "common/GetAllRMCategory";

export const AddEditPMCategory = "pmCategory/addEditPMCategory";
export const DeletePMCategoryById = "pmCategory/DeletePMCategoryById?id={0}";
export const GetAllPMCategory = "common/GetAllPMCategory";

export const AddEditPackingMaterialSize = "packingMaterial/AddEditPackingMaterialSize";
export const DeletePackingMaterialSizeById = "packingMaterial/DeletePackingMaterialSizeById?id={0}";
export const GetAllPackingMaterialSize = "common/GetAllPackingMaterialSize";

export const AddEditStates = "packingMaterial/AddEditStates";
export const DeleteStateById = "packingMaterial/DeleteStateById?id={0}";
export const GetAllStates = "common/GetAllStates";

export const AddEditStereo = "packingMaterial/AddEditStereo";
export const DeleteStereoById = "packingMaterial/DeleteStereoById?id={0}";
export const GetAllStereoData = "common/GetAllStereoData";

export const AddEditLabelClaims = "packingMaterial/AddEditLabelClaims";
export const DeleteLabelClaimById = "packingMaterial/DeleteLabelClaimById?id={0}";
export const GetAllLabelClaims = "common/GetAllLabelClaims";

export const AddEditStorageConditions = "packingMaterial/AddEditStorageConditions";
export const DeleteStorageConditionById = "packingMaterial/DeleteStorageConditionById?id={0}";
export const GetAllStorageConditions = "common/GetAllStorageConditions";

export const AddEditColors = "packingMaterial/AddEditColors";
export const DeleteColorById = "packingMaterial/DeleteColorById?id={0}";
export const GetAllColors = "common/GetAllColors";

export const AddEditMfgLic = "packingMaterial/AddEditMfgLic";
export const DeleteMfgLicById = "packingMaterial/DeleteMfgLicById?id={0}";
export const GetAllMfgLicMaster = "common/GetAllMfgLicMaster";

export const AddEditProductionStages = "packingMaterial/AddEditProductionStages";
export const DeleteProductionStageById = "packingMaterial/DeleteProductionStageById?id={0}";
export const GetAllProductionStageMaster = "common/GetAllProductionStageMaster";

export const AddEditPunchSizeMaster = "packingMaterial/AddEditPunchSizeMaster";
export const DeletePunchSizeById = "packingMaterial/DeletePunchSizeById?id={0}";
export const GetAllPunchSizes = "common/GetAllPunchSizes";

export const AddEditAccountGroup = "packingMaterial/AddEditAccountGroup";
export const DeleteAccountGroupById = "packingMaterial/DeleteAccountGroupById?id={0}";
export const GetAllAccountGroups = "common/GetAllAccountGroups";

export const AddEditTransportCourier = "packingMaterial/AddEditTransportCourier";
export const DeleteTransportCourierById = "packingMaterial/DeleteTransportCourierById?id={0}";
export const GetAllTransportCourier = "common/GetAllTransportCourier?id={0}";

export const AddEditDaybook = "packingMaterial/AddEditDaybook";
export const DeleteDaybookById = "packingMaterial/DeleteDaybookById?id={0}";
export const GetAllDaybooks = "common/GetAllDaybooks?id={0}";

export const GetAllPartyDropdown = "common/GetAllPartyDropdown";
export const GetPartyCorrspAddressById = "common/GetPartyCorrspAddressById?id={0}";
export const GetAllItem = "common/GetAllItem";
export const GetAllProductDropdown = "common/GetAllProductDropdown";
export const GetAllRMDropdown = "common/GetAllRMDropdown";
export const GetAllPackingMaterialDropdown = "common/GetAllPackingMaterialDropdown";
export const GetCompanyDetails = "common/GetCompanyDetails";

// Party Master
export const GetAllParties = "itemMaster/GetAllParties?id={0}";
export const GetPartyDetailsById = "itemMaster/GetPartyDetailsById?id={0}";
export const AddEditPartyDetails = "packingMaterial/AddEditPartyDetails";
export const DeletePartyDetailsById = "packingMaterial/DeletePartyDetailsById?id={0}";
export const GetCompanyDetailsByGSTNumber = "packingMaterial/GetCompanyDetailsByGSTNumber?id={0}";

// Product Details Master
export const GetAllProductDetails = "itemMaster/GetAllProductDetails?id={0}";
export const GetProductDetailById = "itemMaster/GetProductDetailById?id={0}";
export const AddEditProductDetails = "itemMaster/AddEditProductDetails";
export const DeleteProductDetailsById = "itemMaster/DeleteProductDetailsById?id={0}";

// Party Wise NetRate Master
export const GetPartyWiseNetRateDetailsByPartyId = "itemMaster/GetPartyWiseNetRateDetailsByPartyId?id={0}";
export const DeletePartyWiseNetRateById = "itemMaster/DeletePartyWiseNetRateById?id={0}";
export const AddEditpartyWiseNetRateDetails = "itemMaster/AddEditpartyWiseNetRateDetails";

// RM Formula
export const GetRMFormulaByProductId = "itemMaster/GetRMFormulaByProductId?id={0}";
export const AddEditRMFormulaDetails = "itemMaster/AddEditRMFormulaDetails";
export const DeleteRMFurmulaById = "itemMaster/DeleteRMFurmulaById?id={0}";

// PM Formula
export const GetPMFormulaByItemId = "itemMaster/GetPMFormulaByItemId?id={0}";
export const AddEditPMFormulaDetails = "itemMaster/AddEditPMFormulaDetails";
export const DeletePMFurmulaById = "itemMaster/DeletePMFurmulaById?id={0}";

// Test Master
export const AddEditTestMaster = "testMaster/AddEditTestMaster";
export const GetAllTestMaster = "testMaster/GetAllTestMaster";
export const DeleteTestById = "testMaster/DeleteTestById?id={0}";

// QC Monogram Raw Material
export const AddQCMonoGram = "testMaster/AddQCMonoGram";
export const UpdateQCMonoGram = "testMaster/UpdateQCMonoGram";
export const GetQCMonogramByRMId = "testMaster/GetQCMonogramByRMId?id={0}";
export const DeleteQCMonogramById = "testMaster/DeleteQCMonogramById?id={0}";

// QC Monogram Packing Material
export const GetQCMonogramByPMId = "testMaster/GetQCMonogramByPMId?id={0}";

// QC Monogram Packing Material
export const GetQCMonogramByProductId = "testMaster/GetQCMonogramByProductId?id={0}";

// Inventory - G.R.N Entry
export const GetGRNNo = "Inventory/GetGRNNo";
export const AddEditGRNEntryMaterialMapping = "Inventory/AddEditGRNEntryMaterialMapping";
export const GetAllPartyListForGRNEntry = "Inventory/GetAllPartyListForGRNEntry";
export const GetAllgrnEntryMaterialDetailsById = "Inventory/GetAllgrnEntryMaterialDetailsById?id={0}";
export const GetPurchaseOrderMaterialByPartyId = "Inventory/GetPurchaseOrderMaterialByPartyId";
export const DeleteGRNEntryMaterialDetailsById = "Inventory/DeleteGRNEntryMaterialDetailsById?id={0}";
export const DeleteItemforGRNEntryMaterialById = "Inventory/DeleteItemforGRNEntryMaterialById?id={0}";

// Inventory - Additional Entry
export const AddEditAdditionalEntryMaterialMapping = "Inventory/AddEditAdditionalEntryMaterialMapping";
export const GetAllAdditionalEntryMaterialDetailsById = "Inventory/GetAllAdditionalEntryMaterialDetailsById?id={0}";
export const GetAllAdditionalEntryList = "Inventory/GetAllAdditionalEntryList";
export const DeleteAdditionalEntryDetailsById = "Inventory/DeleteAdditionalEntryDetailsById?id={0}";
export const DeleteAdditionalEntryMaterialDetailsById = "Inventory/DeleteAdditionalEntryMaterialDetailsById?id={0}";

// Inventory - Purchase Order
export const AddEditPurchaseOrderDetails = "Inventory/AddEditPurchaseOrderDetails";
export const GetAllPurchaseOrders = "Inventory/GetAllPurchaseOrders";
export const AddEditPurchaserOrderMaterialDetails = "Inventory/AddEditPurchaserOrderMaterialDetails";
export const GetPurchaseOrderMaterialDetailsByPurchaseOrderId = "Inventory/GetPurchaseOrderMaterialDetailsByPurchaseOrderId?id={0}";
export const DeletePurchaseOrderDetailsById = "Inventory/DeletePurchaseOrderDetailsById?id={0}";
export const DeletepurchaseOrderMaterialDetialsById = "Inventory/DeletepurchaseOrderMaterialDetialsById?id={0}";
export const SendPurchaseOrderMail = "Inventory/SendPurchaseOrderMail";
export const ApprovePurchaseOrderByPurchaseId = "Inventory/ApprovePurchaseOrderByPurchaseId?id={0}";

// Inventory - Inquiry Entry
export const AddEditInquiryDetails = "Inventory/AddEditInquiryDetails";
export const GetallInquiryDetails = "Inventory/GetallInquiryDetails";
export const GetAllInquiryMaterialDetailsByInquiryId = "Inventory/GetAllInquiryMaterialDetailsByInquiryId?id={0}";
export const DeleteInquiryDetailsById = "Inventory/DeleteInquiryDetailsById?id={0}";
export const DeleteInquiryMaterialDetailsById = "Inventory/DeleteInquiryMaterialDetailsById?id={0}";
export const SendInquiryToCompany = "Inventory/SendInquiryToCompany";

// Reports
export const GetAllGoodsRegistered = "Inventory/GetAllGoodsRegistered";
export const GetAllMaterialWisePurchaseReport = "Inventory/GetAllMaterialWisePurchaseReport";
export const GetAllItemsForStockLedgerReport = "Inventory/GetAllItemsForStockLedgerReport";
export const GetAllStatementForPurchaseItemByItemId = "Inventory/GetAllStatementForPurchaseItemByItemId";
export const GetAllShourtageReport = "Inventory/GetAllShourtageReport";
export const GetAllNearExpiryReport = "Inventory/GetAllNearExpiryReport";
export const GetAllPurchaseOrderRegister = "Inventory/GetAllPurchaseOrderRegister";


// Production

// Production Planning
export const AddEditProductionPlanningEntry = "Production/AddEditProductionPlanningEntry";
export const GetAllProductionPlanningEntry = "Production/GetAllProductionPlanningEntry";
export const GetProductionPlanningEntryById = "Production/GetProductionPlanningEntryById?id={0}";
export const DeleteProductionPlanningEntryById = "Production/DeleteProductionPlanningEntryById?id={0}";
export const GetRMFormulaForProductionById = "Production/GetRMFormulaForProductionById?id={0}";
export const ProductionRequisitionRMFormulaListing = "Production/ProductionRequisitionRMFormulaListing";
export const GetProductionRMFOrmulaByProductionDetailsId = "Production/GetProductionRMFOrmulaByProductionDetailsId?id={0}";
export const RemoveProductionPlanningEntryFromProductionRequisition = "Production/RemoveProductionPlanningEntryFromProductionRequisition?id={0}";

// Packing Requisition
export const GetPMFormulaByPackingItemId = "Production/GetPMFormulaByPackingItemId?id={0}";
export const PackingRequisitionPMFormulaListing = "Production/PackingRequisitionPMFormulaListing";
export const GetProductionPMFOrmulaByProductionDetailsId = "Production/GetProductionPMFOrmulaByProductionDetailsId?id={0}";
export const RemoveProductionPlanningEntryFromPackingRequisition = "Production/RemoveProductionPlanningEntryFromPackingRequisition?id={0}";

// Batch Clearing
export const AddEditBatchClearingEntry = "Production/AddEditBatchClearingEntry";
export const GetBatchClearingEntryByProductId = "Production/GetBatchClearingEntryByProductId?id={0}";
export const GetAllBatchClearedRecords = "Production/GetAllBatchClearedRecords";
export const DeleteBatchCLearingEntryById = "Production/DeleteBatchCLearingEntryById";
export const RemoveProductionPlanningEntryFromBatchCLearingEntryById = "Production/RemoveProductionPlanningEntryFromBatchCLearingEntryById?id={0}";

// Reports
export const GetAllPendingProductionPlanningReport = "Production/GetAllPendingProductionPlanningReport";
export const GetAllProductionBatchRegister = "Production/GetAllProductionBatchRegister";
export const GetAllJobChargeRecords = "Production/GetAllJobChargeRecords";
export const GetProductCostingReport = "Production/GetProductCostingReport";
export const GetProductDetailsForBatchClearedByProductId = "Production/GetProductDetailsForBatchClearedByProductId?id={0}";
export const GetBatchCostingReportRMFormulaId = "Production/GetBatchCostingReportRMFormulaId?id={0}";
export const GetBatchCostingReportPMFormulaById = "Production/GetBatchCostingReportPMFormulaById?id={0}";
export const GetAllMaterialRequirementReportForRM = "Production/GetAllMaterialRequirementReportForRM";
export const GetAllMaterialRequirementReportForPM = "Production/GetAllMaterialRequirementReportForPM";

// Despatch

// GST Invoice Finish Goods
export const GetProductionStockByProductId = "Despatch/GetProductionStockByProductId?id={0}";
export const GetGSTInvoiceFinishGoodsInvoiceNo = "Despatch/GetGSTInvoiceFinishGoodsInvoiceNo";
export const AddEditGSTInvoiceFinishGoods = "Despatch/AddEditGSTInvoiceFinishGoods";
export const GetAllGSTInvoiceFinishGoodsRecords = "Despatch/GetAllGSTInvoiceFinishGoodsRecords";
export const GetGSTInvoiceFinishGoodsById = "Despatch/GetGSTInvoiceFinishGoodsById?id={0}";
export const DeleteItemFromDBById = "Despatch/DeleteItemFromDBById";
export const DeleteInvoiceById = "Despatch/DeleteInvoiceById?id={0}";
export const GenerateGSTInvoiceForFinishGoodsById = "Despatch/GenerateGSTInvoiceForFinishGoodsById";
export const GenerateProformaInvoice = "Despatch/GenerateProformaInvoice";
export const UpdateSalesOrderProforma = "Despatch/UpdateSalesOrderProforma";
export const SendGSTInvoiceFinishGoodsToClient = "Despatch/SendGSTInvoiceFinishGoodsToClient?id={0}";
export const GenerateEInvoiceById = "Despatch/GenerateEInvoiceById?id={0}";
export const GenerateEwayBill = "Despatch/GenerateEwayBill";
export const CancelEInvoiceById = "Despatch/CancelEInvoiceById";

// GST Invoice RM
export const GetGSTInvoiceRMInvoice = "Despatch/GetGSTInvoiceRMInvoice";
export const GetrawMaterialStockByRMId = "Despatch/GetrawMaterialStockByRMId";
export const AddEditInvoiceRM = "Despatch/AddEditInvoiceRM";
export const GetAllGSTInvoiceRMRecords = "Despatch/GetAllGSTInvoiceRMRecords";
export const GetGSTInvoiceRMById = "Despatch/GetGSTInvoiceRMById?id={0}";
export const DeleteRMItemFromDBById = "Despatch/DeleteRMItemFromDBById";
export const DeleteRMInvoiceById = "Despatch/DeleteRMInvoiceById?id={0}";
export const GenerateGSTInvoiceForRMById = "Despatch/GenerateGSTInvoiceForRMById";
export const SendGSTInvoiceRMToClient = "Despatch/SendGSTInvoiceRMToClient?id={0}";

// GST Invoice PM
export const GetGSTInvoicePMInvoiceNo = "Despatch/GetGSTInvoicePMInvoiceNo";
export const GetPakcingMaterialStockByPMID = "Despatch/GetPakcingMaterialStockByPMID";
export const AddEditInvoicePM = "Despatch/AddEditInvoicePM";
export const GetAllGSTInvoicePMRecords = "Despatch/GetAllGSTInvoicePMRecords";
export const GetGSTInvoicePMById = "Despatch/GetGSTInvoicePMById?id={0}";
export const DeletePMItemFromDBById = "Despatch/DeletePMItemFromDBById";
export const DeletePMInvoiceById = "Despatch/DeletePMInvoiceById?id={0}";
export const GenerateGSTInvoiceForPMById = "Despatch/GenerateGSTInvoiceForPMById";
export const SendGSTInvoicePMToClient = "Despatch/SendGSTInvoicePMToClient?id={0}";

// Sales Order Entry
export const AddEditSalesOrderEntry = "Despatch/AddEditSalesOrderEntry";
export const GetAllOrderDetailsItemMappingById = "Despatch/GetAllOrderDetailsItemMappingById?id={0}";
export const GetAllSalesOrderEntry = "Despatch/GetAllSalesOrderEntry";
export const DeleteSalesOrderById = "Despatch/DeleteSalesOrderById?id={0}";
export const DeleteSalesOrderItemByItemId = "Despatch/DeleteSalesOrderItemByItemId?id={0}";

// Sales Goods Teturn Entry
export const GetSalesGoodsReturnEntryInvoiceNo = "Despatch/GetSalesGoodsReturnEntryInvoiceNo";
export const GetAllBatchesForItemByItemId = "Despatch/GetAllBatchesForItemByItemId?id={0}";
export const AddEditSalesGoodsReturnEntry = "Despatch/AddEditSalesGoodsReturnEntry";
export const GetAllSalesGoodsReturnEntry = "Despatch/GetAllSalesGoodsReturnEntry";
export const GetSalesGoodsReturnDetailsById = "Despatch/GetSalesGoodsReturnDetailsById?id={0}";
export const DeleteSalesGoodsReturnItemById = "Despatch/DeleteSalesGoodsReturnItemById";
export const DeleteSalesGoodsReturnById = "Despatch/DeleteSalesGoodsReturnById?id={0}";
export const GetCompanyAddressByCompanyId = "Despatch/GetCompanyAddressByCompanyId?id={0}";

// Other Delivery Challan
export const GetSerialNoForDeliveryChallan = "Despatch/GetSerialNoForDeliveryChallan";
export const AddEditDeliveryChallan = "Despatch/AddEditDeliveryChallan";
export const GetallOtherDeliveryChallanList = "Despatch/GetallOtherDeliveryChallanList";
export const GetOtherDeliveryChallanDetailsById = "Despatch/GetOtherDeliveryChallanDetailsById?id={0}";
export const DeleteItemDeliveryChallanById = "Despatch/DeleteItemDeliveryChallanById?id={0}";
export const DeleteOtherDeliveryChallanById = "Despatch/DeleteOtherDeliveryChallanById?id={0}";
export const PrintOtherDeliveryChallanById = "Despatch/PrintOtherDeliveryChallanById";

// Reports 
// Party wise Despatch Report
export const GetAllPartyWiseDespatchItem = "Despatch/GetAllPartyWiseDespatchItem";
export const GetAllPartyWiseDespatchItemById = "Despatch/GetAllPartyWiseDespatchItemById?id={0}";

// Party wise Despatch Report
export const GetAllItemWiseDesptach = "Despatch/GetAllItemWiseDesptach";

// Item Wise Monthly Sales
export const GetALLItemWiseMonthlySales = "Despatch/GetALLItemWiseMonthlySales";

// Party Wise Monthly Sales
export const GetAllPartyWiseMonthlySalesByPartyId = "Despatch/GetAllPartyWiseMonthlySalesByPartyId?id={0}";

// Stock StatementReport
export const GetAllStockStatementReport = "Despatch/GetAllStockStatementReport";
export const GetALLStockStatementByProductId = "Despatch/GetALLStockStatementByProductId?id={0}&id2={1}";
export const GetAllBatchWiseStockStatementReport = "Despatch/GetAllBatchWiseStockStatementReport";

// Stock Ledger Report
export const GetAllStockLedgerReport = "Despatch/GetAllStockLedgerReport";
export const GetAllStockLedgerReportBatchStock = "Despatch/GetAllStockLedgerReportBatchStock";

// Near Expiry Stock Report
export const GetAllNearExpiryStockReport = "Despatch/GetAllNearExpiryStockReport";

// Inward post entry 
export const AddEditInwardPost = "Despatch/AddEditInwardPost";
export const GetAllInwardPost = "Despatch/GetAllInwardPost";
export const GetInwardPostById = "Despatch/GetInwardPostById?id={0}";
export const DeleteInwardPostById = "Despatch/DeleteInwardPostById?id={0}";

// Outward post entry
export const AddEditOutwardPost = "Despatch/AddEditOutwardPost";
export const GetAllOutwardPost = "Despatch/GetAllOutwardPost";
export const GetOutwardPostById = "Despatch/GetOutwardPostById?id={0}";
export const DeleteOutwardPostById = "Despatch/DeleteOutwardPostById?id={0}";

// Inward Outward post entry report 
export const GetAllInwardOutwardRegister = "Despatch/GetAllInwardOutwardRegister";

// Account

// Receipt Entry
export const GetReceiptEntryVoucherNo = "Account/GetReceiptEntryVoucherNo";
export const GetAllPendingInvoiceByPartyId = "Account/GetAllPendingInvoiceByPartyId?id={0}";
export const AddEditReceiptEntry = "Account/AddEditReceiptEntry";
export const GetAllReceiptEntry = "Account/GetAllReceiptEntry";
export const GetReceiptDetailsByReceiptId = "Account/GetReceiptDetailsByReceiptId?id={0}";
export const DeleteReceiptDetailsByReceiptId = "Account/DeleteReceiptDetailsByReceiptId?id={0}";

// Payment Entry
export const GetPaymentEntryVoucherNo = "Account/GetPaymentEntryVoucherNo";
export const GetAllPendingInvoiceForPaymentEntryByPartyId = "Account/GetAllPendingInvoiceForPaymentEntryByPartyId?id={0}";
export const AddEditPaymentEntry = "Account/AddEditPaymentEntry";
export const GetAllPaymnetEntry = "Account/GetAllPaymnetEntry";
export const GetPaymentDetailsByPaymnetReceiptId = "Account/GetPaymentDetailsByPaymnetReceiptId?id={0}";
export const DeletePaymentDetailsByPaymentReceiptId = "Account/DeletePaymentDetailsByPaymentReceiptId?id={0}";

// Contra Entry
export const GetContraEntryVoucherNo = "Account/GetContraEntryVoucherNo";
export const AddEditContraEntry = "Account/AddEditContraEntry";
export const GetAllContraEntry = "Account/GetAllContraEntry";
export const GetContraEntryById = "Account/GetContraEntryById?id={0}";
export const DeleteContraEntryById = "Account/DeleteContraEntryById?id={0}";
export const GetBankBalanceByBankId = "Account/GetBankBalanceByBankId?id={0}";

// GST Purchase Entry
export const GetGSTPurchseEntrySRNo = "Account/GetGSTPurchseEntrySRNo";
export const GetAllPendingGRNPurchaseEntry = "Account/GetAllPendingGRNPurchaseEntry";
export const UpdateGRNEntryToPurchaseEntry = "Account/UpdateGRNEntryToPurchaseEntry";
export const AddEditGSTPurchaseEntryRMPM = "Account/AddEditGSTPurchaseEntryRMPM";
export const GetAllGSTPurchaseEntryRMPM = "Account/GetAllGSTPurchaseEntryRMPM";
export const GetGSTPurchaseEntryRMPMById = "Account/GetGSTPurchaseEntryRMPMById?id={0}";
export const GetLastPurchaseRawmaterialRate = "Account/GetLastPurchaseRawmaterialRate?id={0}&id2={1}";
export const DeleteGSTPurchaseEntryRMPMById = "Account/DeleteGSTPurchaseEntryRMPMById?id={0}";

// GST Purchas Entry Without Inventory
export const GetGSTPurchseWithoutInventoryEntrySRNo = "Account/GetGSTPurchseWithoutInventoryEntrySRNo";
export const AddEditGSTPurchaseEntryWithoutInventory = "Account/AddEditGSTPurchaseEntryWithoutInventory";
export const GetAllPurchaseEntryWithoutInventory = "Account/GetAllPurchaseEntryWithoutInventory";
export const GetGSTPurchaseEntryWithoutInventoryById = "Account/GetGSTPurchaseEntryWithoutInventoryById?id={0}";
export const DeleteGSTPurchaseEntryWithoutInventoryById = "Account/DeleteGSTPurchaseEntryWithoutInventoryById?id={0}";

// General Debit Note Entry
export const GetGeneralDebitNoteEntrySRNo = "Account/GetGeneralDebitNoteEntrySRNo";
export const AddEditGeneralDebitNoteEntry = "Account/AddEditGeneralDebitNoteEntry";
export const GetAllGeneralDebitNoteEntry = "Account/GetAllGeneralDebitNoteEntry";
export const GetGeneralDebitNoteEntryById = "Account/GetGeneralDebitNoteEntryById?id={0}";
export const DeleteGeneralDebitNoteEntryById = "Account/DeleteGeneralDebitNoteEntryById?id={0}";
export const GenerateDebitNoteEntryById = "Account/GenerateDebitNoteEntryById";

// General Credit Note Entry
export const GetGeneralCreditNoteEntrySRNo = "Account/GetGeneralCreditNoteEntrySRNo";
export const AddEditGeneralCreditNoteEntry = "Account/AddEditGeneralCreditNoteEntry";
export const GetAllGeneralCreditNoteEntry = "Account/GetAllGeneralCreditNoteEntry";
export const GetGeneralCreditNoteEntryById = "Account/GetGeneralCreditNoteEntryById?id={0}";
export const DeleteGeneralCreditNoteEntryById = "Account/DeleteGeneralCreditNoteEntryById?id={0}";
export const GenerateCreditNoteEntryById = "Account/GenerateCreditNoteEntryById";

// J.V. Entry
export const GetJVEntryVoucherNo = "Account/GetJVEntryVoucherNo";
export const AddEditJVEntry = "Account/AddEditJVEntry";
export const GetAllJVEntry = "Account/GetAllJVEntry";
export const GetJVEntryById = "Account/GetJVEntryById?id={0}";
export const DeleteJVEntryById = "Account/DeleteJVEntryById?id={0}";

// Reports 
export const GetAllAccountLedger = "Account/GetAllAccountLedger";
export const GetAllPendingInvoicePaymentReport = "Account/GetAllPendingInvoicePaymentReport";
export const GetAllBankWiseCashBankBookReport = "Account/GetAllBankWiseCashBankBookReport?id={0}&id2={1}";
export const GetRunningBalanceByPartyId = "Account/GetRunningBalanceByPartyId?id={0}";
export const GetAllMonthWiseCashBankBookReportbyBankId = "Account/GetAllMonthWiseCashBankBookReportbyBankId?id={0}&id2={1}&id3={2}";
export const GetAllDateWiseCashBankBookReportbyBankId = "Account/GetAllDateWiseCashBankBookReportbyBankId";
export const GetAllGroupWiseAccountSummary = "Account/GetAllGroupWiseAccountSummary";
export const GetAllOpeningBalanceReport = "Account/GetAllOpeningBalanceReport";
export const GetAllGSTSalesRegister = "Account/GetAllGSTSalesRegister";
export const GetAllGSTPurchaseRegister = "Account/GetAllGSTPurchaseRegister";
export const GetGSTCalculationList = "Account/GetGSTCalculationList";


// Utility 
// User Profile 
export const GetUserProfile = "Utility/GetUserProfile";
export const AddEditUserProfile = "Utility/AddEditUserProfile";

// Admin Role 
export const GetAllAdminRoles = "Utility/GetAllAdminRoles";
export const GetAllAdminsByCompanyId = "Utility/GetAllAdminsByCompanyId?id={0}";
export const GetadminById = "Utility/GetadminById?id={0}";
export const AddEditAdmin = "Utility/AddEditAdmin";
export const DeleteAdminById = "Utility/DeleteAdminById?id={0}";


//User Log
export const GetAllUserLog = "Utility/GetAllUserLog";


// Dashboard  
export const GetAllProductionPlanningNumber = "Dashboard/GetAllProductionPlanningNumber?id={0}";
export const GetTopSellingProducts = "Dashboard/GetTopSellingProducts?id={0}";
export const GetTopActiveClients = "Dashboard/GetTopActiveClients?id={0}";
export const GetMonthlySalesAndPurchase = "Dashboard/GetMonthlySalesAndPurchase?id={0}";

//QC

// Raw Material
export const GetGRNItemsByGRNNo = "qc/GetGRNItemsByGRNNo?id={0}";
export const GetRawMaterialSampleEntryCount = "qc/GetRawMaterialSampleEntryCount";
export const AddEditRawMaterialSampleEntry = "qc/AddEditRawMaterialSampleEntry";
export const GetAllRawMaterialSampleEntry = "qc/GetAllRawMaterialSampleEntry?id={0}&id1={1}&id2={2}";
export const GetRawMaterialSampleEntryDetailsById = "qc/GetRawMaterialSampleEntryDetailsById?id={0}";
export const DeleteRawMaterialSampleEntryById = "qc/DeleteRawMaterialSampleEntryById?id={0}";
export const GenerateSampleEntryRmReport = "qc/GenerateSampleEntryRmReport?id={0}";

// Packing Material
export const GetPackingMaterialSampleEntryCount = "qc/GetPackingMaterialSampleEntryCount";
export const AddEditPackingMaterialSampleEntry = "qc/AddEditPackingMaterialSampleEntry";
export const GetAllPackingMaterialSampleEntry = "qc/GetAllPackingMaterialSampleEntry?id={0}&id1={1}&id2={2}";
export const GetPackingMaterialSampleEntryDetailsById = "qc/GetPackingMaterialSampleEntryDetailsById?id={0}";
export const DeletePackingMaterialSampleEntryById = "qc/DeletePackingMaterialSampleEntryById?id={0}";
export const GenerateSampleEntryPmReport = "qc/GenerateSampleEntryPmReport?id={0}";

// Finish Goods
export const GetFinishGoodsSampleEntryCount = "qc/GetFinishGoodsSampleEntryCount";
export const GetProductionItemsByProductionNo = "qc/GetProductionItemsByProductionNo?id={0}";
export const AddEditFinishGoodsSampleEntry = "qc/AddEditFinishGoodsSampleEntry";
export const GetAllFinishGoodsSampleEntry = "qc/GetAllFinishGoodsSampleEntry?id={0}&id1={1}&id2={2}";
export const GetFinishGoodsSampleEntryDetailsById = "qc/GetFinishGoodsSampleEntryDetailsById?id={0}";
export const DeleteFinishGoodsSampleEntryById = "qc/DeleteFinishGoodsSampleEntryById?id={0}";
export const GenerateSampleEntryFGReport = "qc/GenerateSampleEntryFGReport?id={0}";

// Raw Material Test Report Entry
export const GetAllPeningRawMaterialSampleEntry = "qc/GetAllPeningRawMaterialSampleEntry?id={0}&id1={1}&id2={2}";
export const AddEditRawMaterialTestReport = "qc/AddEditRawMaterialTestReport";
export const GetAllRawMaterialTestReportEntry = "qc/GetAllRawMaterialTestReportEntry?id={0}&id1={1}";
export const GetRawMaterialTestEntryDetailsById = "qc/GetRawMaterialTestEntryDetailsById?id={0}";
export const DeleteRawMaterialTestEntryById = "qc/DeleteRawMaterialTestEntryById?id={0}";
export const GenerateTestingEntryRmReport = "qc/GenerateTestingEntryRmReport?id={0}";

// Packing Material Test Report Entry
export const GetAllPeningPackingMaterialSampleEntry = "qc/GetAllPeningPackingMaterialSampleEntry?id={0}&id1={1}&id2={2}";
export const AddEditPackingMaterialTestReport = "qc/AddEditPackingMaterialTestReport";
export const GetAllPackingMaterialTestReportEntry = "qc/GetAllPackingMaterialTestReportEntry?id={0}&id1={1}";
export const GetPackingMaterialTestEntryDetailsById = "qc/GetPackingMaterialTestEntryDetailsById?id={0}";
export const DeletePackingMaterialTestEntryById = "qc/DeletePackingMaterialTestEntryById?id={0}";
export const GenerateTestingEntryPmReport = "qc/GenerateTestingEntryPmReport?id={0}";


// Finish Goods Test Report Entry
export const GetAllPeningFinishGoodsSampleEntry = "qc/GetAllPeningFinishGoodsSampleEntry?id={0}&id1={1}&id2={2}";
export const AddEditFinishGoodsTestReport = "qc/AddEditFinishGoodsTestReport";
export const GetAllFinishGoodsTestReportEntry = "qc/GetAllFinishGoodsTestReportEntry?id={0}&id1={1}";
export const GetFinishGoodsTestEntryDetailsById = "qc/GetFinishGoodsTestEntryDetailsById?id={0}";
export const DeleteFinishGoodsTestEntryById = "qc/DeleteFinishGoodsTestEntryById?id={0}";
export const GenerateTestingEntryFGReport = "qc/GenerateTestingEntryFGReport?id={0}";
